module.exports = __webpack_public_path__ + "img/retail-blue.dd04f338.png";